import { getAPI } from "./axios-base";

export default class RestResourceBrand {
  getBrands(params: { skip: number; limit: number }) {
    return getAPI.get("api/rest/v1/brand", {
      params: params
    });
  }
  postBrand(body: any) {
    return getAPI.post("api/rest/v1/brand", body);
  }
  getBrand(id: string) {
    return getAPI.get(`api/rest/v1/brand/${id}`);
  }
  putBrand(id: string, body: any) {
    return getAPI.put(`api/rest/v1/brand/${id}`, body);
  }
}
